export const ROOT_URL = process.env.NODE_ENV === "production" || process.env.NODE_ENV === "development" ? process.env.REACT_APP_SERVER : "";